import src from "IMAGE";
export default { src, width: 587, height: 231, blurWidth: 0, blurHeight: 0};
